import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Nav.css';

const NAV_ITEMS = [
  { key: 'today',      label: 'Today',      path: '/app/today' },
  { key: 'focus',      label: 'Focus',      path: '/app/focus' },
  { key: 'plans',      label: 'Plans',      path: '/app/plans' },
  { key: 'insights',   label: 'Insights',   path: '/app/insights' },
  { key: 'reflection', label: 'Reflection', path: '/app/reflection' },
];

const Icon = ({ name, active }) => {
  const stroke = active ? 'var(--gold-500)' : 'var(--ink-mute)';
  const fill = active ? 'var(--gold-300)' : 'none';
  switch (name) {
    case 'today':
      return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <circle cx="12" cy="12" r="3.6" fill={fill} stroke={stroke} />
          <path d="M12 2v3.2M12 18.8V22M2 12h3.2M18.8 12H22M4.6 4.6l2.3 2.3M17.1 17.1l2.3 2.3M4.6 19.4l2.3-2.3M17.1 6.9l2.3-2.3" />
        </svg>
      );
    case 'focus':
      return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="5" />
          <circle cx="12" cy="12" r="1.6" fill={active ? 'var(--gold-400)' : stroke} stroke="none" />
        </svg>
      );
    case 'plans':
      return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <rect x="3.5" y="4.5" width="17" height="16" rx="2.5" />
          <path d="M3.5 9.5h17M8 3v3.5M16 3v3.5" />
        </svg>
      );
    case 'insights':
      return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M3.5 17.5c2.5-1 3.8-3.6 5.2-5.6s2.8-4 5.2-4 3.6 2.6 6.6 5.6" />
          <circle cx="14" cy="7.9" r="1.3" fill={active ? 'var(--gold-400)' : stroke} stroke="none" />
        </svg>
      );
    case 'reflection':
      return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M5 6.5c0-1.4 1.1-2.5 2.5-2.5h9c1.4 0 2.5 1.1 2.5 2.5v11c0 1.4-1.1 2.5-2.5 2.5H8.2L5 22.2V6.5z" />
          <path d="M9 10h6M9 13.5h4" />
        </svg>
      );
    default:
      return null;
  }
};

const SunMark = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--gold-500)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="12" r="3.6" fill="var(--gold-300)" stroke="var(--gold-500)" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.6 4.6l2.1 2.1M17.3 17.3l2.1 2.1M4.6 19.4l2.1-2.1M17.3 6.7l2.1-2.1" />
  </svg>
);

export { SunMark };

export default function Nav({ hidden = false }) {
  const navigate = useNavigate();
  const location = useLocation();

  const currentKey = (() => {
    const p = location.pathname;
    if (p.includes('/today')) return 'today';
    if (p.includes('/focus')) return 'focus';
    if (p.includes('/plans')) return 'plans';
    if (p.includes('/insights')) return 'insights';
    if (p.includes('/reflection') || p.includes('/chat') || p.includes('/ai')) return 'reflection';
    return 'today';
  })();

  return (
    <nav className={`hx-nav ${hidden ? 'hx-nav-hidden' : ''}`} aria-label="Primary">
      <div className="hx-nav-inner">
        {NAV_ITEMS.map(item => {
          const active = item.key === currentKey;
          return (
            <button
              key={item.key}
              className={`hx-nav-item ${active ? 'is-active' : ''}`}
              onClick={() => navigate(item.path)}
              aria-current={active ? 'page' : undefined}
            >
              <span className="hx-nav-icon">
                <Icon name={item.key} active={active} />
              </span>
              <span className="hx-nav-label">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
